/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Archaeological_Sciences27Inputs */

const en__field_enum_study_archaeological_sciences27 = /** @type {(inputs: _Field_Enum_Study_Archaeological_Sciences27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archaeological Sciences`)
};

const de__field_enum_study_archaeological_sciences27 = /** @type {(inputs: _Field_Enum_Study_Archaeological_Sciences27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archäologische Wissenschaften`)
};

/**
* | output |
* | --- |
* | "Archaeological Sciences" |
*
* @param {_Field_Enum_Study_Archaeological_Sciences27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_archaeological_sciences27 = /** @type {((inputs?: _Field_Enum_Study_Archaeological_Sciences27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Archaeological_Sciences27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_archaeological_sciences27(inputs)
	return de__field_enum_study_archaeological_sciences27(inputs)
});
export { _field_enum_study_archaeological_sciences27 as "_field_enum_STUDY_ARCHAEOLOGICAL_SCIENCES" }